module.exports = require("yargs");


//////////////////
// WEBPACK FOOTER
// external "yargs"
// module id = 11
// module chunks = 0